module.exports = __webpack_public_path__ + "img/1498496664.9175a4c7.jpg";